import { render, staticRenderFns } from "./freezer.vue?vue&type=template&id=25f79f96&scoped=true&"
import script from "./freezer.vue?vue&type=script&lang=js&"
export * from "./freezer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f79f96",
  null
  
)

export default component.exports